import React, { useEffect, useRef, useState } from 'react';
import { PageContainer, FilterPod, LoadingPage, ExportButton, TableComponents, Icons, ReceiveFile } from 'components';
import { Link as RouterLink } from 'react-router-dom';
import { useStyles } from './style';
import { Grid, Button, Box } from '@mui/material';
import useCustomHook from '../hooks';
import jMoment from 'moment-jalaali';
import { useExportFile , useCurrencyUnit} from 'hooks';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import DiscountCodesServices from './services/DiscountCodesServices';
import { columns, generateData } from './components/Columns';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import axios from 'axios';
import { getExportDiscountVoucherUrl} from 'URLs';
const AssignedDelegation = () => {
  // -- STATES --//
  const {
    loading,
    setLoading,
    filterParams,
    setFilterParams,
    guildListLoading,
    setGuildListLoading,
    filters,
    setFilters,
    size,
    setSize,
    page,
    setPage,
    setGuildsList,
    paramsData,
    setParamsData
  } = useCustomHook();

  const currencyText = useCurrencyUnit(false);

  // --HOOKS--//
  const classes = useStyles();
  const tableRef = useRef();

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  const { downloadFile, isExporting } = useExportFile({
    url: getExportDiscountVoucherUrl(),
    filename: 'credit-voucher-guild',
  });


  /**
* لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
*/
  const actionsList =
    getDynamicObjectAction([
      'voucherList',
      'voucherDetailAction',
      'voucherToggleStatusAction',
      'voucherExportBtn',
    ]);

  useEffect(() => {
    if (actionsList['voucherList']) {
      const getGuildsList = async (val = '') => {
        setGuildListLoading(false);
        try {
          const q = { query: encodeURI(val) };
          const result = await DiscountCodesServices.getGuildsList(q);
          const data = result.result.guilds;

          if (data.length > 0) {
            let list = [];
            list = data.map((val) => ({
              name: val.name,
              id: val.id,
              label: val.name,
              value: val.id,
              code: val?.code,
            }));
            setGuildsList(list);

            const tempFilters = [...filters];
            const i = tempFilters.findIndex((v) => v?.keyName === 'guildCode');
            if (i < 0) return;
            tempFilters[i] = {
              ...tempFilters[i],
              filterProps: {
                ...tempFilters[i].filterProps,
                options: [...list.map((v) => ({ label: v?.name, value: v?.code }))],
              },
            };
            setFilters(tempFilters);

            setGuildListLoading(false);
          }
        } catch (e) {
          setGuildListLoading(false);
        }
      };

      getGuildsList(); // used for filters.
    }

  }, []);

  // --API REQUESTS--//
  const getDicsountCodes = async (query) => {

    try {
      setLoading(true);

      // TODO: Handle Order By (is not provided by server side)
      const orderBy = [];
      // let orderByName = null;

      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);

      // default filter should not contains Credit Charge Voucher
      if (!queries.hasOwnProperty('type')) {
        queries.type = 2 + 4 + 8 + 16;
      }

      jMoment.loadPersian({ usePersianDigits: false });
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        startDate: '1396/01/01 00:00:00',
        endDate: jMoment(new Date().setHours(23, 59, 0, 0)).format('jYYYY/jMM/jDD 23:59:59'),
        ...queries,
      };
      const defaultParam = {
        ...params, startDate: null,
        endDate: null,
      }
      setParamsData({ ...defaultParam });
      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await DiscountCodesServices.getVourchers(params);

      let list = [];
      if (res.result) {


        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }

      setLoading(false);

      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };


  const onChangeStatus = async (id, newStatus) => {

    try {
      await DiscountCodesServices.changeVoucherStatus(id, newStatus);
      tableRef?.current?.onChangeTable();

    } catch (error) {
      setLoading(false);
    }
  };

  const onExport = (type, index) => {
    const types = ['xls', 'csv'];
    downloadFile(types[index], filterParams?.data, filterParams?.params);
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0)
    setSize(10)
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100)
  };

  const hint = 'در این بخش می‌توانید لیست بن‌های تخفیف صادر‌ شده  را مشاهده کنید.';

  return (
    <PageContainer
      title="لیست بن‌های تخفیف"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.VOUCHER_LIST}
      className={classes.root}
    >
      <Grid item xs={12}>
        <Box display="flex"
          justifyContent='end'
          alignItems="flex-end"
          style={{ marginBottom: 16 }}
          className={classes.btnActions}
        >
          {
            actionsList['voucherList'] &&
            <FilterButton
              setOpenFilterDialog={setOpenFilterDialog}
              filters={filters}
            />
          }
          {

            actionsList['voucherExportBtn'] &&
            actionsList['voucherList'] &&
            <ReceiveFile
              type={'voucher'}
              paramsData={paramsData}
              allowedTypesFormat={['CSV', 'XLS']}
              isFormatExport={true}
              classBtn={classes.exportBtn}
            />
          }
        </Box>

        <Box>

          <FilterPod
            filters={filters}
            onChange={onFiltersChange}
            openFilterDialog={openFilterDialog}
            setOpenFilterDialog={setOpenFilterDialog}
            handleCloseFilterDialog={handleCloseFilterDialog}
          />

        </Box>
      </Grid>

      {guildListLoading ? (
        <LoadingPage />
      ) : (
        (actionsList['voucherList'] && currencyText) &&
          <TableComponents
            data={getDicsountCodes}
            columns={columns(SeeDetailBtn, onChangeStatus, actionsList , currencyText)}
            isLoading={loading}
            ref={tableRef}
            onChange={(ps) => {
              setPage(ps?.pageNumber)
              setSize(ps?.pageSize)
              return getDicsountCodes(ps)
            }}

          />
      )}
    </PageContainer>
  );
};

// See detail for every row

const SeeDetailBtn = ({ id }) => {
  const classes = useStyles();
  return (
    <RouterLink to={`/Voucher/Detail/${id}`}>
      <Button startIcon={<Icons icon="MoreHorizontal" color="#667585" size="20" />}
        variant="contained" className={classes.expandBtn}>
        جزئیات
      </Button>
    </RouterLink>
  );
};

export default AssignedDelegation;
